import "./about.css";
import Sunflower from "../../assets/sunflower.png";
import Tshepiso from "../../assets/tshepiso.png";
import Paintings from "../../assets/painting.png";
import { NavLink } from "../../components/navbar/navbar.component";
import { useEffect, useRef } from "react";

function About() {
  const images = [
    {
      source: Sunflower,
      altText: "hobby image",
    },
    {
      source: Tshepiso,
      altText: "my image",
    },
    {
      source: Paintings,
      altText: "hobby image",
    },
  ];

  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;

    if (container) {
      container.scrollTo({
        left: 0,
        behavior: "smooth",
      });
    }

    const images = container.querySelectorAll(".about-image");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          } else {
            entry.target.classList.remove("in-view");
          }
        });
      },
      {
        root: container,
        threshold: 0.5,
      }
    );

    images.forEach((image) => observer.observe(image));

    return () => {
      images.forEach((image) => observer.unobserve(image));
    };
  }, []);

  return (
    <div
      className="page page-padding d-flex flex-column align-items-center pb-0"
      id={NavLink.ABOUT_ME}
    >
      <div className="heading align-self-start padding-v-40 no-padding-top">
        <div className="font-sub-heading font-bold">About Me.</div>
      </div>
      <div className="about-main-text font-sub-1 font-semi-normal padding-v-30 px-4">
        I’m Tshepiso, a <span className="font-bold">UX/UI designer</span> from
        Krugersdorp, South Africa, with a passion for{" "}
        <span className="font-bold">
          creating intuitive, human-centered experiences
        </span>
        . My journey began in hospitality, where I learned the{" "}
        <span className="font-bold">value of service </span>,
        <span className="font-bold">empathy</span>, and{" "}
        <span className="font-bold">attention to detail</span> skills I now
        bring into <span className="font-bold">design</span>. After discovering
        UX through a Google Coursera course, I became captivated by crafting{" "}
        <span className="font-bold">digital solutions</span> that{" "}
        <span className="font-bold">connect people</span> and make life simpler.
        Outside design, I express <span className="font-bold">creativity</span>{" "}
        through <span className="font-bold">art</span>,{" "}
        <span className="font-bold">beauty</span> and{" "}
        <span className="font-bold">everyday life</span>, always driven by
        people, <span className="font-bold">problem-solving</span> and great
        design.
      </div>
      <div className="about-container" ref={containerRef}>
        {images.map((image, index) => (
          <img
            key={index}
            className="about-image"
            src={image.source}
            alt={image.altText}
          />
        ))}
      </div>
    </div>
  );
}

export default About;
